import * as React from 'react';
import {useState} from 'react';
import {IntlProvider} from 'react-intl';
import messages_bg from "./lib/textProperties/bg.json"
import {Key, SWRConfig, SWRHook} from "swr";
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import {PreloaderContextProvider} from "./lib/context/PreloaderContext";
import {UserContextProvider} from "./lib/context/UserContext";
import axios from "axios";
import {ToastContextProvider} from "./lib/context/ToastContext";
import {AxiosInterceptor} from "./lib/AxiosInterceptor";
import {DialogContextProvider} from "./lib/context/DialogContext";
import {HeaderContextProvider} from "./lib/context/HeaderContext";
import {KeyboardContextProvider} from "./lib/context/KeyboardContext";


interface Props {
}

export const AppProxy: React.FC<Props> = (props) => {
    const messages = {'bg': messages_bg}
    const [interceptorReady, setInterceptorReady] = useState(false);

    const handleInterceptorReady = () => {
        setInterceptorReady(true);
    };

    const proxyMiddleware = (next: SWRHook) => {
        return (key: Key, fetcher: any, config: any) => {
            const extendedFetcher = (...args: any) => {
                args.push(true);
                return fetcher(args);
            }

            return next(key, extendedFetcher, config);
        }
    }

    return <>
        <IntlProvider locale={"bg-BG"} messages={messages.bg}>
            <PreloaderContextProvider>
                <ToastContextProvider>
                    <DialogContextProvider>
                        <UserContextProvider>
                            <AxiosInterceptor callback={handleInterceptorReady}>
                                <KeyboardContextProvider>
                                    {interceptorReady ?
                                        <HeaderContextProvider>
                                            <SWRConfig value={{
                                                fetcher: ([url, isSWR]) => axios(url, {data: {isSWR}}).then(response => response.data),
                                                use: [proxyMiddleware]
                                            }}>
                                                <BrowserRouter>
                                                    <App/>
                                                </BrowserRouter>
                                            </SWRConfig>
                                        </HeaderContextProvider>
                                        : null}
                                </KeyboardContextProvider>
                            </AxiosInterceptor>
                        </UserContextProvider>
                    </DialogContextProvider>
                </ToastContextProvider>
            </PreloaderContextProvider>
        </IntlProvider>
    </>
};
